import React from 'react';

const popupStyles = {
  success: {
    background: '#15803d', // darker green
    color: '#fff'
  },
  error: {
    background: '#b91c1c', // darker red
    color: '#fff'
  },
  info: {
    background: '#1e40af', // darker blue
    color: '#fff'
  }
};

const PopupMessage = ({ message, type = 'info', onClose }) => {
  if (!message) return null;

  return (
    <div
      style={{
        ...popupStyles[type],
        position: 'absolute',
        top: '120px',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: '10px 20px',
        borderRadius: '8px',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        textAlign: 'center',
        whiteSpace: 'normal',
        maxWidth: '90%',
        wordWrap: 'break-word'
      }}
    >
      {message}
      <button
        onClick={onClose}
        style={{
          marginLeft: '10px',
          background: 'none',
          border: 'none',
          color: '#fff',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default PopupMessage;
